import { Injectable } from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {ApiService} from '../../services/api.service';
import {Store} from '../../store';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class BlogService {
    env = environment;

    constructor(
        private http: HttpClient,
        private apiService: ApiService,
        private store: Store,
    ) {
    }

    getCategories() {
        return this.http.get(this.env.apiPath + 'blog/categories', this.apiService.getHttpOptions()).pipe(map((data: any) => {
            return data.data;
        }));
    }

    getCategory(slug) {
        return this.http.get(this.env.apiPath + 'blog/categories/' + slug, this.apiService.getHttpOptions()).pipe(map((data: any) => {
            return data.data;
        }));
    }

    getArticlesByCategory(params) {
        const dataToSend = {
            params,
        };
        return this.http.post(this.env.apiPath + 'blog/categories/search', dataToSend, this.apiService.getHttpOptions()).pipe(map((data: any) => {
            return data.data;
        }));
    }

    getArticle(slug, viewDraft: boolean) {
        const params = new URLSearchParams()
        if (viewDraft) {
            params.set('view_draft', '1')
        }
        return this.http.get(this.env.apiPath + 'blog/article/' + slug + `?${params.toString()}`, this.apiService.getHttpOptions()).pipe(map((data: any) => {
            return data.data;
        }));

    }

}
